module.exports = __webpack_public_path__ + "static/media/LIFESTYLE.2cdd2d71.jpg";